import React from "react";

const ZonasHorarias = ({ value, onChange }) => {
  return (
    <select className="fiscal-control" value={value} onChange={onChange}>
      <optgroup label="🇲🇽 México">
        <option value="GMT-6">Ciudad de México (GMT-6)</option>
        <option value="GMT-5">Cancún (GMT-5)</option>
        <option value="GMT-8">Tijuana (GMT-8)</option>
        <option value="GMT-6-MTY">Monterrey (GMT-6)</option>
        <option value="GMT-7">Mazatlán (GMT-7)</option>
        <option value="GMT-7-HS">Hermosillo (GMT-7)</option>
        <option value="GMT-7-CH">Chihuahua (GMT-7)</option>
      </optgroup>

      <optgroup label="🌎 América del Norte">
        <option value="GMT-5-NY">Nueva York (GMT-5)</option>
        <option value="GMT-6-CHI">Chicago (GMT-6)</option>
        <option value="GMT-7-DEN">Denver (GMT-7)</option>
        <option value="GMT-8-LA">Los Ángeles (GMT-8)</option>
        <option value="GMT-5-TO">Toronto (GMT-5)</option>
        <option value="GMT-8-VA">Vancouver (GMT-8)</option>
      </optgroup>

      <optgroup label="🌎 América Central y Caribe">
        <option value="GMT-6-GUA">Guatemala (GMT-6)</option>
        <option value="GMT-6-CR">San José, Costa Rica (GMT-6)</option>
        <option value="GMT-5-PAN">Panamá (GMT-5)</option>
        <option value="GMT-5-LH">La Habana (GMT-5)</option>
        <option value="GMT-4-SD">Santo Domingo (GMT-4)</option>
      </optgroup>

      <optgroup label="🌎 América del Sur">
        <option value="GMT-5-BOG">Bogotá (GMT-5)</option>
        <option value="GMT-5-LIM">Lima (GMT-5)</option>
        <option value="GMT-3-STG">Santiago (GMT-3)</option>
        <option value="GMT-3-BA">Buenos Aires (GMT-3)</option>
        <option value="GMT-3-SP">São Paulo (GMT-3)</option>
        <option value="GMT-4-CA">Caracas (GMT-4)</option>
      </optgroup>

      <optgroup label="🌍 Europa">
        <option value="GMT+0">Londres (GMT+0)</option>
        <option value="GMT+1-PAR">París (GMT+1)</option>
        <option value="GMT+1-MAD">Madrid (GMT+1)</option>
        <option value="GMT+1-ROM">Roma (GMT+1)</option>
        <option value="GMT+1-AM">Ámsterdam (GMT+1)</option>
        <option value="GMT+1-BR">Bruselas (GMT+1)</option>
        <option value="GMT+1-ZU">Zúrich (GMT+1)</option>
        <option value="GMT+3-MO">Moscú (GMT+3)</option>
      </optgroup>

      <optgroup label="🌏 Asia">
        <option value="GMT+4">Dubái (GMT+4)</option>
        <option value="GMT+9">Tokio (GMT+9)</option>
        <option value="GMT+9-SE">Seúl (GMT+9)</option>
        <option value="GMT+8-SH">Shanghái (GMT+8)</option>
        <option value="GMT+8-HK">Hong Kong (GMT+8)</option>
        <option value="GMT+8-SI">Singapur (GMT+8)</option>
        <option value="GMT+7-BA">Bangkok (GMT+7)</option>
        <option value="GMT+5:30">Calcuta (GMT+5:30)</option>
      </optgroup>

      <optgroup label="🌏 Oceanía">
        <option value="GMT+11">Sídney (GMT+11)</option>
        <option value="GMT+11-ME">Melbourne (GMT+11)</option>
        <option value="GMT+13">Auckland (GMT+13)</option>
      </optgroup>
    </select>
  );
};

export default ZonasHorarias;
